




<template>
  <v-container>

     <div id="map" style="height:545px; border-style: solid; border-color: #2196F3"></div>

  </v-container>
</template>



<script>










  export default {
    name: 'MapDiv',

    data: () => ({

     
    }),


  }



</script>
